import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';

import WifiStandardBadge from 'modules/bottomPanel/containers/WifiStandardIcon';
import OutdoorSwitch from 'modules/bottomPanel/containers/OutdoorSwitch';
import MountSwitch from 'modules/bottomPanel/containers/MountSwitch';
import ApDevicePanel, { ApDevicePanelProps } from '../components/compositions/ApDevicePanel';
import ChangeAntennaButton from './ChangeAntennaButton';
import DevicePickerDropdown from './DevicePickerDropdown';
import DevicePickerImage from './DevicePickerImage';

const ApDevicePanelContainer = (props: Partial<ApDevicePanelProps>) => {
  const { leftId } = useBottomPanel();

  if (!leftId) {
    return null;
  }

  return (
    <ApDevicePanel
      id={leftId}
      ChangeAntennaButton={ChangeAntennaButton}
      DevicePickerDropdown={DevicePickerDropdown}
      DevicePickerImage={DevicePickerImage}
      WifiStandardIcon={WifiStandardBadge}
      OutdoorSwitch={OutdoorSwitch}
      MountSwitch={MountSwitch}
      {...props}
    />
  );
};

export default ApDevicePanelContainer;
